import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

export const writeAccountingReport = ({
  t,
  id,
  searchValues,
  responseReportData,
}: stdObject) => {
  let balance = responseReportData.previous;
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: [
        { NAME: t("p.previousBalance"), BALCAJ: toPrice(balance) },
        ...responseReportData.list
          .sort((a: stdObject, b: stdObject) =>
            a.FECCAJ.localeCompare(b.FECCAJ),
          )
          .map((e: stdObject) => {
            balance = e.RESCAJ ? e.ENTCAJ : balance + e.ENTCAJ - e.SALCAJ;
            return {
              ...e,
              NAME:
                e.MKEY === "DIN"
                  ? t(`c.${e.NOMCAJ}`) + ` ${e.SERDIN}-${e.CODDIN}`
                  : e.NOMCAJ +
                    (e.RESCAJ ? ` (${t("p.balanceCorrection")})` : ""),
              ENTCAJ: e.ENTCAJ === 0 ? "-" : toPrice(e.ENTCAJ),
              SALCAJ: e.SALCAJ === 0 ? "-" : toPrice(e.SALCAJ),
              BALCAJ: toPrice(balance),
              BGCOLOR: e.RESCAJ ? colors.lightYellow : null,
            };
          }),
      ],
    },
  };
};
